import { ruleRunner } from 'validations/ruleRunner';
import { ruleIf, required } from 'validations/rules';

const Validations = [
  ruleRunner('recovery_email', 'nome do remetente de e-mail para recuperação', ruleIf('sales_recovery', required))
];

export default Validations;
